<div
  class="bg-white rounded border border-gray-200 overflow-auto"
  style="max-height: 60vh"
>
  <table class="min-w-full table-auto border-collapse border-gray-500">
    <thead class="bg-gray-100 sticky top-0 z-10">
      <tr>
        <th class="text-left px-4 py-3 font-medium text-gray-700 w-12">N°</th>
        <th
          *ngFor="let col of columns"
          class="text-left px-4 py-3 font-medium text-gray-700"
        >
          {{ col.header }}
        </th>
        <th
          *ngIf="actions?.length"
          class="text-center px-4 py-3 font-medium text-gray-700"
        >
          Acciones
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of data; let i = index"
        class="hover:bg-gray-50 transition"
      >
        <td
          class="px-4 py-2 text-sm text-gray-700 border-t border-gray-200 text-left w-12"
        >
          {{ i + 1 }}
        </td>
        <td
          *ngFor="let col of columns"
          class="px-4 py-2 text-sm text-gray-700 border-t border-gray-200"
        >
          {{ getNestedValue(item, col.field) }}
        </td>
        <td
          *ngIf="actions?.length"
          class="px-4 py-2 text-center border-t border-gray-200"
        >
          <div class="flex justify-center gap-2">
            <button
              *ngIf="actions.includes('view')"
              (click)="view.emit(item)"
              class="text-blue-500 hover:text-blue-700"
              title="Ver detalles"
            >
              <ng-icon name="heroEye" size="20"></ng-icon>
            </button>
            <button
              *ngIf="actions.includes('edit')"
              (click)="edit.emit(item)"
              class="text-green-500 hover:text-green-700"
              title="Editar"
            >
              <ng-icon name="heroPencilSquare" size="20"></ng-icon>
            </button>
            <button
              *ngIf="actions.includes('delete')"
              (click)="remove.emit(item)"
              class="text-red-500 hover:text-red-700"
              title="Eliminar"
            >
              <ng-icon name="heroTrash" size="20"></ng-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div
  *ngIf="showPagination"
  class="mt-4 flex items-center justify-end space-x-3 mb-4 mr-6 text-sm text-gray-600"
>
  <button
    (click)="prevPage()"
    [disabled]="page === 1"
    class="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
  >
    <ng-icon name="matArrowBackIosOutline"></ng-icon>
  </button>
  <span>Página {{ page }}</span>
  <button
    (click)="nextPage()"
    [disabled]="page * pageSize >= total"
    class="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
  >
    <ng-icon name="matArrowForwardIosOutline"></ng-icon>
  </button>
</div>
